<template>
    <div class="maintenance-page vh-100 d-flex align-items-center justify-content-center">
        <div class="text-center">
            <div class="maintenance-icon mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#6c757d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
                </svg>
            </div>
            <h2 class="fw-600 text-dark mb-3">{{ $t('시스템 점검 중') }}</h2>
            <p class="text-muted mb-2 f-110">
                {{ $t('현재 시스템 점검이 진행 중입니다.') }}
            </p>
            <p class="text-muted mb-4 f-110">
                {{ $t('잠시 후 다시 접속해 주시기 바랍니다.') }}
            </p>
            <small class="text-muted">
                {{ $t('불편을 드려 죄송합니다.') }}
            </small>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MaintenancePage',
};
</script>

<style scoped>
.maintenance-page {
    background-color: #f8f9fa;
}

.maintenance-icon {
    opacity: 0.6;
}
</style>
